import Vue from "vue";

export const busHome = new Vue();
